import { HStack, Text, Tooltip } from "@chakra-ui/react";

import { countDocsByBucket } from "./docStatus";

type Props = {
  documents: Parameters<typeof countDocsByBucket>[0];
};

/** approved / completed / missing, as counts in the bucket colors. */
export default function TasksV2DocumentsSummary({ documents }: Props) {
  if (documents.length === 0) {
    return <>—</>;
  }

  const counts = countDocsByBucket(documents);

  return (
    <Tooltip
      hasArrow
      label={`${counts.approved} approved · ${counts.completed} completed · ${counts.missing} missing`}
      placement="top"
    >
      <HStack
        display="inline-flex"
        fontWeight="semibold"
        spacing={0.5}
        sx={{ fontVariantNumeric: "tabular-nums" }}
      >
        <Text as="span" color="blue.500">
          {counts.approved}
        </Text>
        <Text as="span" color="gray.400">
          /
        </Text>
        <Text as="span" color="green.500">
          {counts.completed}
        </Text>
        <Text as="span" color="gray.400">
          /
        </Text>
        <Text as="span" color="red.500">
          {counts.missing}
        </Text>
      </HStack>
    </Tooltip>
  );
}
